import axios from '../../store/middleware/axiosInstance';

class HammMedia {
	upload = (file, key, onUploadProgress = () => {}) => {
		return new Promise((resolve, reject) => {
			let formData = new FormData();
			formData.append('file', file);
			axios
				.request({
					headers: {
						'X-Hammurabi-Key': `${process.env.REACT_APP_HAMMURABI_KEY}`,
						'Content-Type': 'multipart/form-data',
					},
					method: 'POST',
					url: `${process.env.REACT_APP_HAMMURABI_API}/utils/profilepic/${key}`,
					data: formData,
					onUploadProgress,
				})
				.then(({ data }) => {
					resolve(data);
				})
				.catch(e => {
					reject(e);
				});
		});
	};

	// Signed, short-lived URLs for files in the private bucket (POST /utils/media/sign, with the user's JWT)
	sign = urls =>
		axios
			.post(`${process.env.REACT_APP_HAMMURABI_API}/utils/media/sign`, { urls })
			.then(({ data }) => data);
}

const instance = new HammMedia();

export default instance;
